import { WeekSchedule } from 'graphql/generated/graphqlTypes';

export function generateMockWeekSchedule({ weekDays = [] }: Partial<Omit<WeekSchedule, '__typename'>>): WeekSchedule {
  return {
    __typename: 'WeekSchedule',
    weekDays
  };
}
